export default __webpack_public_path__ + "app/build/static/media/logo.ccefcd54.svg";